<div class="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
    <img src="assets/img/msg-loader.svg" alt="Loading">
    <p class="fw-bold">Hold on...</p>
    <p>You might have landed on a wrong page.</p>
</div>
